import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import Select, { components } from "react-select";
import classes from "../ServicesTable.module.scss"
import { E2Data, DDD } from "../../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Button from "../../UI/Button";
import { useForm, Controller  } from "react-hook-form";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import { Autocomplete, TextField } from "@mui/material";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const EU_Units = new E2Data("EU_Units");
EU_Units.format = "full";
const options = [
    { label: "Option 1", value: "val1" },
    { label: "Option 2", value: "val2" },
    { label: "Option 3", value: "val3" },
    { label: "Option 4", value: "val5" },
    { label: "Option 5", value: "val6" },
    { label: "Option 6", value: "val7" },
  ];

const Workflow = forwardRef(({ orgData, deviceData, stepData, workflow, value, onComplete, onUIWorkflow, formData, autoExecute=false}, ref) => {
    const [activeWorkflow, setActiveWorkflow] = useState();
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(0);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        getValues,
    } = useForm();

    useEffect(() => {
        if(activeWorkflow) return;
        if(!workflow || workflow.length === 0) return;
        
        setActiveWorkflow(workflow);
    },[workflow, activeWorkflow]);

    useEffect(() => {
        if(!activeWorkflow) return;
        let next = findNextExecutable(start);
        if(next === false){
            if(hasFields(start, activeWorkflow.length-1)) return;
            if(autoExecute) {_executeWorkflows(start, activeWorkflow.length-1); return;};
            return setEnd(activeWorkflow.length-1);
        }

        if(autoExecute) {_executeWorkflows(start, activeWorkflow.length-1); return;};

        setEnd(next);
    }, [activeWorkflow]);

    const findNextExecutable = (start) => {
        for(let i = start; i < activeWorkflow.length; i++) {
            if(activeWorkflow[i]?.execute?.button) {
                return i;
            }
        }
        return false;
    }

    const _executeWorkflows = async(start, end, data) => {
        if(!isPositiveNum(start) || !isPositiveNum(end) || start > end) return console.error("Invalid start or end in workflow execution");
        //let wfs = [...activeWorkflow];
        let wfs = JSON.parse(JSON.stringify(activeWorkflow));
        if(data) populateWFWithData(start, end, wfs, data);
        await executeWFs(start, end, wfs);
        if(getError(wfs)){
            if(onComplete) onComplete(wfs, getError(wfs));
            return wfs;
        }
        if(end === activeWorkflow.length-1) {
            if(onComplete) onComplete(wfs, getError(wfs));
            return wfs;
        }else{
            setActiveWorkflow(wfs);
            setStart(end+1);
            let next = findNextExecutable(end+1);
            if(next === false){
                yolo.current=1;
                return setEnd(activeWorkflow.length-1)
                //return setTimeout(() => {workflowSubmit();}, 1000);
            }
            setEnd(next);
        }
    }
    const yolo = useRef(null);
    useEffect(() =>{
        if(!yolo.current) return;
        yolo.current=false;
        workflowSubmit();
    }, [end]);

    const getError = (wfs) => {
        for(let i = 0; i < wfs.length; i++) {
            if(wfs[i]?.error) return wfs[i]?.error;
        }
        return false;
    }

    const executeWFs = async (start, end, wfs) => {
        for(let i = start; i <= end; i++) {
            if(wfs[i]?.type?.toLowerCase() === "ui" && onUIWorkflow) {
                onUIWorkflow(wfs[i]);
                continue;
            }

            if(!wfs[i]?.execute) continue;

            try{
                let res = await executeWF(wfs[i], wfs)
                if(res?.result && res?.result?.Status !== "Error")
                    wfs[i].response = res.result;
                if(res?.error || res?.result?.Status === "Error"){
                    wfs[i].error = res.error || res.result;
                    console.error("Error in workflow execution: ", res.error || res.result);
                    return;
                }
            }catch(e) {
                console.error(e);
            }
        }
    }

    const executeWF = async (wf, wfs) => {
        if(!wf?.execute) return null;
        let exstr = JSON.stringify(wf.execute);
        exstr = changeExpressions(exstr, {device : deviceData, aorg: orgData, value: value, workflow: wfs, "this": wf});
        if(!exstr) return console.error("Could not change expressions in workflow execution");
        const executeExpr = JSON.parse(exstr);
        if(wf?.type === "table")  copyTableField(executeExpr, wf);
        if(!executeExpr?.method) return console.error("No method in execute expression");
        const ddd = new DDD(apiRequestAddress);
        let res = await ddd.Rpc_ExecuteMethod(executeExpr.method, executeExpr.params);
        return res;
    }

    const copyTableField = (executeExpr, wf) => {
        if(!wf || !wf?.fields || !executeExpr) return;
        //executeExpr.params.entity= wf?.table;
        if(!executeExpr?.params?.values) executeExpr.params.values = {};
        Object.keys(wf.fields).forEach((key) => {
            executeExpr.params.values[key] = wf.fields[key].value || null;
        });
    }
    const populateWFWithData = (start, end, wf, data) => {
        for(let i = start; i <= end; i++) {
            if(!wf[i]?.fields) continue;
            Object.keys(wf[i]?.fields).forEach((key) => {
                if(data?.hasOwnProperty(key)) {
                    wf[i].fields[key].value = data[key];
                }
            });
        }
    }

    const workflowSubmit = (data) => {
        _executeWorkflows(start, end, data);
    }

    const hasFields = (start, end) => {
        for(let i = start; i <= end; i++) {
            if(activeWorkflow[i]?.fields) return true;
        }
        return false;
    }

    const onBtnClick = (e) => {
        e.preventDefault();
        handleSubmit((data) => {
            workflowSubmit(data);
        })(e);
    }

    const isPositiveNum = (value) =>{
        return typeof value === "number" && value >= 0;
    }

    const wfHasButton = (wfs) => {
        if(!wfs) return false;
        return wfs?.some(wf => wf?.execute?.button);
    }

    const executeWorkflows = async (newData) => {
        if(wfHasButton(activeWorkflow)) return true;
        
        return await _executeWorkflows(start, end, getValues);
    }

    useImperativeHandle(ref, () => ({
        executeWorkflows,
    }), [start, end, workflow, activeWorkflow, orgData, deviceData, stepData, value, formData, onUIWorkflow]);

    return (
        start >= 0 && end>=start && <>
            <form className={classes["input-container"]}>
                {activeWorkflow?.map((step, index) => {
                    if(index < start || index > end) return null;
                    if(!step?.fields) return null;
                    return <div style={{width:"100%"}}>
                        {Object.entries(step?.fields).map(([key, value]) => {
                            return (<>
                                {value.type==="checkbox" ? (<>
                                    <div key={key} className={`mt-1 d-flex`} /* style={{borderBottom:"1px solid var(--main-blue)"}} */>
                                        <label>
                                            {value?.title}:
                                            {value?.tooltip && <GenericTooltip tooltip={value?.tooltip} fieldName={key} placement="left"/>}
                                        </label>
                                        <input {...register(key, {required: value?.required})} type={value?.type} />
                                    </div>
                                </>): value.type === "list" ? (<>
                                    <label>
                                        {value?.title}
                                        {value?.tooltip && <GenericTooltip tooltip={value?.tooltip} fieldName={key} placement="left"/>}
                                    </label>
                                    <Controller
                                        name={key}
                                        control={control}
                                        render={({ field }) => (
                                        <Autocomplete
                                            multiple
                                            options={value.options}
                                            getOptionLabel={(option) => option.label}
                                            onChange={(_, selectedOptions) => {
                                                field.onChange(selectedOptions.map((opt) => opt.value));
                                            }}
                                            renderInput={(params) => <TextField {...params} size="small" sx={{
                                                "& .MuiInputBase-input": {
                                                  outline: "none",
                                                }
                                              }}/>}
                                        />
                                        )}
                                    />
                                </>): (<>
                                    <div key={key} className={`${classes["input-group"]} mt-1`}>
                                        <label>
                                            {value?.title}
                                            {value?.required && <span className="text-danger">*</span>}
                                            {value?.tooltip && <GenericTooltip tooltip={value?.tooltip} fieldName={key} placement="left"/>}
                                        </label>
                                        <input {...register(key, {required: value?.required})} type={value?.type} />
                                        {errors[key] && <span className="text-danger mt-1">{t("This field is required")}</span>}
                                    </div>
                                </>)}
                             </>)
                        })}
                        <hr/>
                    </div>
                })}
                {activeWorkflow?.[end]?.execute?.button && !autoExecute && <div className="text-center w-100">
                    <Button onClick={onBtnClick} className="px-5 py-1 ms-3" >
                        {activeWorkflow?.[end]?.execute?.button}
                    </Button>
                </div>}
            </form>
        </>
    );
});

export default Workflow;


/*
device -> The device row we're on (VP_DevicesOrgUnits)
value -> Kaj je napisano ta trenutek v tem inputu
this -> trenuten kontekst. Če si znotraj workflowa imenovanega "wf1" recimo, potem this se nanaša na "wf1"
workflow.<identifier>.response -> se lahko sklicuješ na podatke workflowa višje. workflow.<id>.response to bo JSON object responsa executa. Recimo, Data.Create vrne obliko {result : { id : ""}}
workflow.<identifier>.fields -> to se lahko skicuješ na vrednosti ki so v fieds. To bodo fizično texfieldi na ekranu ki nekdo vpiše nekaj
aorg -> EU_AOrg vrstica
*/
const changeExpressions = (str, data) => {
    if(!str) return str;
    const keys = extractCommentKeys(str);
    if(Object.keys(keys).length === 0) return str;
    Object.keys(keys).forEach((key) => {
        const parts = parseCommentString(key);
        if(parts.length === 0) return;
        let val =null;
        switch(parts[0]) {
            case "device":
            case "aorg":
                val = getNestedValue(data, parts);
                keys[key] = val===undefined ? null : val;
                break;
            case "value":
                if(parts[1]){keys[key] = data?.value?.[parts[1]] ? data.value[parts[1]] : null;}
                else{ keys[key] = data.value === undefined ? null : data.value;}
                break;
            case "workflow":
                if(!parts[1]) return console.error("Invalid workflow identifier");
                let wfname = parts[1];
                const fwf = data.workflow.find(wf => wf.name === wfname);
                if(!fwf) return console.error("Could not find workflow with name: ", wfname);
                let subparts = parts.slice(2);
                val = getNestedValue(fwf, subparts);
                keys[key] = val===undefined ? null : val;
                break;
            case "this":
                val = getNestedValue(data, parts);
                keys[key] = val===undefined ? null : val;
                break;
            default:
                break;
        }
    });
    
    return replaceKeysInString2(keys, str);
};

const getNestedValue = (obj, keyArray) => {
    return keyArray.reduce((current, key) => current && current[key], obj);
}

const extractCommentKeys = (inputString) => {
    const regex = /<!--.*?-->/g;
    const matches = {};
    let match;

    while ((match = regex.exec(inputString)) !== null) {
        const key = match[0];
        matches[key] = true; 
    }

    return matches;
}

const parseCommentString = (commentString) => {
    if (!commentString.startsWith('<!--') || !commentString.endsWith('-->')) return [];

    const trimmed = commentString.slice(4, -3).trim();
    return trimmed.split('.').map(part => part.trim());
}

const replaceKeysInString = (obj, str) => {
    for (const [key, value] of Object.entries(obj)) {
        str = str.split(key).join(value);
    }
    return str;
}

const replaceKeysInString2 = (obj, str) => {
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "boolean" || typeof value === "number" || value === null) {
            str = str.replace(new RegExp(`"${key}"`, 'g'), value);
            str = str.replace(new RegExp(`${key}`, 'g'), value);
        }else if(Array.isArray(value)){
            str = str.replace(new RegExp(`"${key}"`, 'g'), JSON.stringify(value));
        } else {
            str = str.split(key).join(value);
        }
    }
    return str;
};